import { useEffect } from 'react';

export const useDocumentTitle = (shortOrgName: string) => {
  useEffect(() => {
    const prevTitle = document.title;

    const newTitle = shortOrgName
      ? shortOrgName + ' | DroneReport'
      : 'DroneReport';

    document.title = newTitle;
    return () => {
      document.title = prevTitle;
    };
  });
};
